import { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { CurrentUserContext } from "../../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faFileLines,
  faKey,
  faSignOutAlt,
  faUnlock,
  faUserCircle,
  faExchangeAlt,
} from "@fortawesome/free-solid-svg-icons";
import iconUserDefault from "../../../asset/icon/iconuser.svg";
import ModalSwitchRole from "../../material/modal/ModalSwitchRole";

const MenuInfoPatient = ({ setOpenModal, setOpenMenu }) => {
  const navigate = useNavigate();
  const { setUserRole } = useContext(CurrentUserContext);

  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch (e) {
      return {};
    }
  }, []);

  const fullName =
    `${user?.profile?.fname || user?.fname || ""} ${user?.profile?.lname || user?.lname || ""}`.trim();

  useEffect(() => {
    if (user) setUserRole(user);
  }, [user, setUserRole]);

  const handleLogout = () => {
    localStorage.clear();
    setUserRole(null);
    navigate("/login");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 992) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const currentOrigin = window.location.origin;
  const getBaseUrl = currentOrigin.includes('dmsc.moph.go.th') 
    ? currentOrigin 
    : 'https://dmsc-static.devfunction.com';
  const profileImageFile = user?.profile?.profile_image ?? user?.profile_image;

  const imageSrc = useMemo(() => {
    if (!profileImageFile) return iconUserDefault;

    if (profileImageFile.includes("http")) {
      return profileImageFile;
    }

    return `${getBaseUrl}/image/${profileImageFile}`;
  }, [profileImageFile, getBaseUrl]);
  return (
    <>
      {isModalOpen && <ModalSwitchRole onClose={() => setIsModalOpen(false)} />}

      <Menu open={isOpen} handler={setIsOpen} placement="bottom-end">
        <MenuHandler>
          <button className="w-full outline-none">
            <div className="flex h-[81px] w-full items-center justify-between px-4 bg-[#de3c72] hover:bg-[#c62f5f] transition-colors duration-200 shadow-sm">
              <div className="flex items-center gap-3 overflow-hidden">
                <div className="w-12 h-12 min-w-[48px] rounded-full border-2 border-white/20 overflow-hidden bg-white/10">
                  <img
                    src={imageSrc}
                    alt="profile"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex flex-col text-left leading-tight truncate">
                  <span className="text-white font-semibold text-base lg:text-sm truncate">
                    {fullName || "ชื่อผู้ใช้งาน"}
                  </span>
                  <span className="text-white/80 text-xs font-light mt-0.5">
                    แพทย์/เภสัช
                  </span>
                </div>
              </div>

              <div className="text-white ml-8">
                <FontAwesomeIcon
                  icon={faBars}
                  className={`text-xl transition-transform duration-300`}
                />
              </div>
            </div>
          </button>
        </MenuHandler>

        <MenuList className="p-1 border min-w-[240px] bg-white shadow-xl rounded-lg border-blue-gray-50 z-[9999]">
          <MenuListItem
            icon={faUserCircle}
            label="จัดการข้อมูลส่วนตัว"
            onClick={() => navigate("/doctor/ManageInfo")}
          />
          <MenuListItem
            icon={faExchangeAlt}
            label="เปลี่ยนสิทธิ์การใช้งาน"
            onClick={() => {
              setOpenModal(true)
              if (setOpenMenu) setOpenMenu(false)
            }}
          />
          <MenuListItem
            icon={faKey}
            label="เปลี่ยนรหัสผ่าน"
            onClick={() => navigate("/doctor/changePassword")}
          />
          <hr className="my-1 border-gray-100" />
          <MenuListItem
            icon={faSignOutAlt}
            label="ออกจากระบบ"
            onClick={handleLogout}
            className="text-red-500 hover:bg-red-50"
          />
        </MenuList>
      </Menu>
    </>
  );
}

function MenuListItem({ icon, label, onClick, className = "" }) {
  return (
    <MenuItem
      onClick={onClick}
      className={`flex items-center gap-3 p-3 transition-colors hover:bg-gray-100 outline-none ${className}`}
    >
      <div className="w-5 text-center">
        <FontAwesomeIcon icon={icon} className="text-lg" />
      </div>
      <p className="text-sm font-medium font-['Prompt']">{label}</p>
    </MenuItem>
  );
}

export default MenuInfoPatient;
